import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerCarnet: ['request'],
  // registerCarnet: ['period','campus','phone','districtId','address','reference'],
  // Reducer
  registerCarnetClear: null,
  registerCarnetRequest: null,
  registerCarnetSuccess: null,
  registerCarnetFailure: ['error']
});

export { Creators, Types };
